/*
 * Public API Surface of surface3d-design
 */
export * from './lib/surface3d-design.module';
export * from './lib/Icons/surface3d-icons.component';
export * from './lib/MaterialDesign/material-design.module';
